<div class="form-wrapper">
  <div class="box box-background">

    <div class="logo-container mb-5">
      <div class="logo-content">
        <img class="logo is-bordered logo-style logo-hover-pointer" width="250px" alt="Logo" src="assets/logos/symbol3.svg" (click)="goToLogin()"/>
      </div>
    </div>

    @if (token) {
    <app-password
      [requestOld]="false"
      (passwordValidated)="onPasswordSetup($event)">
    </app-password>

    } @else {
    <form [formGroup]="recoveryForm">
      <p class="mb-2">{{ 'password-recovery.email' | translate }}</p>
      <input [ngClass]="{'is-danger': recoveryForm.get('email')?.invalid && recoveryForm.get('email')?.touched}"
             formControlName="email"
             class="input mb-6"
             type="text"
             placeholder="{{ 'password-recovery.email-placeholder' | translate }}">

      <button type="button" class="button is-primary is-fullwidth mb-2 button-30"
              [ngClass]="isSubmitting ? 'is-loading' : ''"
              (click)="submitRecovery()"
              [disabled]="recoveryForm.invalid">
        {{ 'password-recovery.validate' | translate }}
      </button>
    </form>
    }

  </div>
</div>
